var ShipmentCtrl = function(gettextCatalog, $state, $sessionStorage, Notification) {
  this._Notification = Notification;
  this._state = $state;
  this.sessionStorage = $sessionStorage;
  this.gettextCatalog = gettextCatalog;
  this.hasScooter = this.sessionStorage.items.some((item) => item.type === 'scooter');
  this.hasParts = this.sessionStorage.items.some((item) => item.type === 'scooter');
};

ShipmentCtrl.prototype.goToCart = function () {
  this._state.go('app.cart');
};

module.exports = ShipmentCtrl;


// WEBPACK FOOTER //
// ./client/src/app/modules/order/ShipmentCtrl.js